import { CardInfoDto } from "./card-info.dto";

export class CardSuggestionDto{
    /*
    *
    */
    constructor(
      public id?:  number,
      public displaySorting?: number,
      public photo?: string,
      public cardInfo?: CardInfoDto
    ){}
}